<template>
  <div class="data-center-page">
    <div class="bread-tab">
      <span>竞技场</span>
      <el-button @click="addNew()" type="primary" size="mini">新增</el-button>
    </div>
    <el-card>
      <el-table :data="arenaList">
        <el-table-column label="序号" prop="id" width="160px"></el-table-column>
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="活动时间">
          <template slot-scope="scope">
            <span>{{scope.row.startTime | moment}}</span>
            <span> 至 </span>
            <span>{{scope.row.endTime | moment}}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            <span>{{scope.row.createTime | moment}}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否展示">
          <template slot-scope="scope">
            <span>{{scope.row.showed ? '是' : '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300px">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="showLinks(scope.row.id)" class="btn">提取链接</el-button>
            <el-button v-if="scope.row.showed === true" type="danger" size="mini" @click="changeStatus(scope.row.id, false)" class="btn">关闭展示</el-button>
            <el-button v-if="scope.row.showed === false" type="success" size="mini" @click="changeStatus(scope.row.id, true)" class="btn">开启展示</el-button>
            <el-button size="mini" @click="showRankList(scope.row.id)" class="btn">查看榜单</el-button>
            <el-button size="mini" @click="showCurrentRank(scope.row.id)" class="btn">查看排名</el-button>
            <el-button type="warning" size="mini" @click="showUpdate(scope.row.id)" class="btn">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager-wrap">
      <el-pagination
        @size-change="sizeChanged"
        @current-change="currentChanged"
        :current-page.sync="pager.page"
        :page-size="pager.size"
        layout="total, prev, pager, next"
        :total="listTotal"
        background></el-pagination>
      </div>
    </el-card>
    <data-form ref="create" type="create" @submitData="submitSuccess"></data-form>
    <data-form ref="update" type="update" :aid="activeId" @submitData="submitSuccess"></data-form>
    <el-dialog
      :visible.sync="linksVisible"
      width="600px"
      title="提取链接">
      <div>
        <span class="link-label">web链接：</span>
        <a :href="webLink" target="_blank" class="preview-link">{{webLink}}</a>
      </div>
      <div class="link-wrap">
        <span class="link-label">h5链接：</span>
        <a :href="h5Link" target="_blank" class="preview-link">{{h5Link}}</a>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="rankVisible"
      @open="rankOpened"
      @close="rankClosed"
      width="600px"
      title="查看榜单">
      <div>
        <el-button @click="editRankVisible = true" type="primary" size="mini">新增</el-button>
      </div>
      <div class="tb-wrap">
        <el-table :data="rankList">
          <el-table-column type="index" label="排名"></el-table-column>
          <el-table-column prop="userId" label="用户ID"></el-table-column>
          <el-table-column prop="account" label="账号"></el-table-column>
          <el-table-column prop="value" label="数值"></el-table-column>
          <el-table-column prop="value" label="创建时间">
            <template slot-scope="scope">
              <span>{{scope.row.createTime | moment}}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-button v-if="scope.row.fake" @click="showEditRankForm(scope.row.id, scope.row.account, scope.row.value)" type="text">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="currentRankVisible"
      title="查看排名">
      <div class="tb-wrap">
        <el-table :data="currentRank">
          <el-table-column prop="userId" label="用户ID"></el-table-column>
          <el-table-column prop="amount" label="数值"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="editRankVisible"
      @closed="editClosed"
      width="600px"
      title="编辑">
      <div class="form-wrap">
        <el-form :model="editRankForm" label-width="100px">
          <el-form-item label="账号">
            <el-input v-model="editRankForm.account"></el-input>
          </el-form-item>
          <el-form-item label="数值">
            <el-input v-model="editRankForm.value"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="submitEditRank()" type="primary">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import './store.js';
import {mapState, mapActions} from 'vuex';
import DataForm from './components/DataForm';
const PCODE = '5a1fdc37862fe6271e57ea1a193b7e05';
const ACTIVE_DOMAIN = 'alpha.io'
export default {
  name: "DataCenter",
  data() {
    return {
      activeId: '',
      pager: {
        page: 1,
        size: 10
      },
      listTotal: 0,
      linksVisible: false,
      rankVisible: false,
      currentRankVisible: false,
      webLink: '',
      h5Link: '',
      editRankVisible: false,
      editRankId: '',
      editRankForm: {
        arenaId: '',
        account: '',
        value: ''
      }
    };
  },
  methods: {
    ...mapActions('arena', ['getArenaList', 'updateStatus', 'getRankList', 'getCurrentRank', 'editRank']),
    sizeChanged() {},
    currentChanged() {
      this.getArenaList(this.pager);
    },
    addNew() {
      this.$refs['create'].setVisible(true);
    },
    showUpdate(id) {
      this.activeId = id;
      this.$refs['update'].setVisible(true);
    },
    submitSuccess() {
      this.getArenaList(this.pager);
    },
    changeStatus(id, showed) {
      let content = showed ? '确认开启展示？' : '确认关闭展示？';
      this.$confirm(content, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        this.updateStatus({
          id,
          showed
        })
        .then(res => {
          if(!res.code) this.getArenaList(this.pager);
        })
      });
    },
    showLinks(id) {
      let pr = 'https://';
      this.webLink = pr + ACTIVE_DOMAIN + '/arena/' + id + '/' + PCODE;
      this.h5Link = pr + 'h5.' + ACTIVE_DOMAIN + '/arena/' + id + '/' + PCODE;
      this.linksVisible = true;
    },
    showRankList(sid) {
      this.activeId = sid;
      this.getRankList({id: sid});
      this.rankVisible = true;
    },
    showCurrentRank(sid) {
      this.getCurrentRank({id: sid});
      this.currentRankVisible = true;
    },
    rankOpened() {
      //this.getRankList();
    },
    rankClosed() {
      this.activeId = '';
    },
    showEditRankForm(eid, account, value) {
      this.editRankId = eid;
      this.editRankForm.account = account;
      this.editRankForm.value = value;
      this.editRankVisible = true;
    },
    editClosed() {
      this.editRankId = '';
      this.editRankForm.account = '';
      this.editRankForm.value = '';
    },
    submitEditRank() {
      let q = {
        arenaId: this.activeId,
        account: this.editRankForm.account,
        value: parseFloat(this.editRankForm.value)
      };
      if(this.editRankId) q.rankId = this.editRankId;
      this.editRank(q)
      .then(res => {
        let type = res.code == 0 ? "success" : "error";
          this.$message({
            showClose: true,
            message: res.msg,
            type,
          });
          if (res.code == 0) {
            this.editRankVisible = false;
            this.getRankList({id: this.activeId});
          }
      });
    }
  },
  computed: {
    ...mapState('arena', ['arenaList', 'totalCount', 'rankList', 'currentRank'])
  },
  components: {
    DataForm
  },
  watch: {
    totalCount(newVal, oldVal) {
      this.listTotal = newVal;
    }
  },
  mounted() {
    this.getArenaList(this.pager);
  }
};
</script>

<style scoped>
  .bread-tab {
    margin-bottom: 20px;
  }
  .bread-tab span:first-child {
    margin-right: 20px;
  }
  .pager-wrap {
    margin: 20px 0px;
    text-align: right;
  }
  .link-label {
    margin-right: 20px;
  }
  .preview-link {
    color: #406ce9;
  }
  .link-wrap {
    margin-top: 20px;
  }
  .btn {
    margin: 0px 10px 6px 0px;
  }
</style>
